import './bootstrap';
import './bootstrap5/bootstrap.bundle';

//removed alpine here because it's clashing with livewire - https://stackoverflow.com/questions/78389150/error-detected-multiple-instances-of-alpine-running-livewire-3-x-laravel-1 

/* import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
window.Alpine = Alpine;

Alpine.plugin(focus);

Alpine.start(); */
